<template>
  <div
    class="button-link"
    :class="{ black: isBlack, red: isRed, disable: disable, able: !disable }"
    @click="onClick"
    v-html="text"
  ></div>
</template>

<script>
export default {
  name: "button-link",
  props: {
    text: { type: String },
    isBlack: { type: Boolean, default: false },
    isRed: { type: Boolean, default: false },
    disable: { type: Boolean, default: false },
  },
  methods: {
    onClick() {
      if (this.disable) return;
      this.$emit("click-text", this.text);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./../../unified.scss";
.button-link {
  width: 100%;
  margin: 1rem auto;
  text-align: center;
  border-radius: 4px;
  background-color: #5cd5d6;
  padding: 0.75rem 0;
  font-size: 1.1rem;
  color: white;
  font-weight: 700;
}
.black {
  background: #606060;
}
.red {
  background: #ff7c86;
}
.disable {
  background: #c3c3c3;
  color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/Atoms/ButtonTextLink.vue